import api from './api';

export const updateUserTelegram = () => api.patch('/social/telegram');
